import React, { useEffect } from "react";
import "./Newcovid.css";
import NewHeader from "../../components/NewHeader/NewHeader";
import TopNav from "../../components/TopNav/TopNav";
import Header from "../../components/Header/Header";
import ScrolltoTop from "../../components/Scrolltotop/ScrolltoTop";
import Footer from "../../components/Footer/Footer";
import SubFooter from "../../components/SubFooter/SubFooter";
import { Onecomponent } from "../../Pages/Career";
import FAQforhomepage from "../homePage/FAQforhomepage";
import { Link } from "react-router-dom";
import { useSelector } from "react-redux";
import { FaCheck } from "react-icons/fa";
import sam from "../../Assets/newAsset/imaging/sam.webp";
import "../../Pages/homePage/Components/Content.css";
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
import Meta from "../../components/Meta";
import { Scroll } from "../../components/Scroll function/scroll";
import { connect, useDispatch } from 'react-redux';
import Actions from './NewCovidAction';



function Newcovid(props) {
  const covidPacakges = [
    {
      id: 1,
      PackName: "Covid Care Basic",
      packPrice: "1740",
      offer_price: "650",
      parameter: "73",
      slug: "covid-care-basic-test",
      is_premium: false,
    },
    {
      id: 2,
      PackName: "Advance Covid Care",
      packPrice: "1740",
      offer_price: "650",
      parameter: "73",
      slug: "covid-care-advanced-test",
      is_premium: false,
    },
  ];
  const responsive = {
    superLargeDesktop: {
      // the naming can be any, depends on you.
      breakpoint: { max: 4000, min: 3000 },
      items: 5,
    },
    desktop: {
      breakpoint: { max: 3000, min: 1024 },
      items: 3,
    },
    tablet: {
      breakpoint: { max: 1024, min: 464 },
      items: 3,
    },
    mobile: {
      breakpoint: { max: 464, min: 0 },
      items: 1,
    },
  };

  const navCity = useSelector((state) => state.navCityList);
  const { navCities, loading } = navCity;

  const citySelected = useSelector((state) => state.cityOnTopNav);
  useEffect(() => {
    Scroll();
  }, []);

  useEffect(() => {
    props.getCovidpackage('covid',props.SelCity)
    console.log(props.SelCity,"city selected")
  },[props?.SelCity])

  console.log(props.covidPack)
  return (
    <React.Fragment>
      <Meta
        title="Covid Care Packages, Covid Test Near Me - Book Now"
        description="Redcliffe Labs offers the best Covid Care Packages. Book Covid Test, rtpcr test Now and Get Quick Precise Reports as per NABL ISO guidelines. Home Sample collection available."
        keywords="Covid test near me, Covid care packages, Covid test at home, rtpcr test in Noida, Covid test in Noida"
      >
      </Meta>
     <NewHeader faq={true} />

      <div className="covid">
        <div className="covid_content textPink">
          <h1 className="">Protect Your Family Against Covid-19</h1>
          {/**<img src={SamBanner} alt="banner" /> */}
        </div>
        <div className="covidNameImg">
          <img src={sam} className="img_fluid"></img>
        </div>
      </div>
      <Onecomponent
        className="headingCovid"
        title={"Covid Care Packages"}
        content={
          "Once diagnosed with covid-19, it is important to progressively monitor the presence of Cytokine level as excess development of it causes ARDS ( Acute Respiratory Distress Syndrome) which damage tissues, causes multiple organ failure and then death. Mortality in covid-19 patients chains more due to the presence of “Cytokine Storm”, excess production of cytokine-induced by SARS-CoV-2. Hence it is vital to have a keen eye on the check-ups."
        }
      />
      {/* <div className="Covid_Packages_Div">
        <h2> Our Comprehensive Covid Care Packages</h2>
        <div className="covidPackages">
          {covidPacakges.map((card) => (
            <div
              className={
                card.is_premium
                  ? "Package__card bgPremium "
                  : "Package__card bgOrdinary "
              }
              key={card.id}
            >
              <div className="packageTop">
                <span className={card.is_premium ? "bgGreen" : "bgOrange"}>
                  {card.is_premium ? "Most Popular Plan" : "Heath Check-up"}
                </span>{" "}
              </div>

              <div className="packageBottom">
                <div className="Package__cardTitle">
                  <span className={card.is_premium ? "textWhite" : "textBlue "}>
                    <Link
                      className={card.is_premium ? "textWhite" : "textBlue "}
                      to={`/${card.slug}-${citySelected.citySelect
                        .toLowerCase()
                        .replace(" ", "-")}`}
                    >
                      {card.PackName}
                    </Link>
                  </span>
                </div>
                <div className="Package__cardList">
                  <ul>
                    <li>
                      {" "}
                      <FaCheck /> Total no.of Tests - {card.parameter}
                    </li>
                    <li>
                      {" "}
                      <FaCheck /> Quick Turn Around Time{" "}
                    </li>
                    <li>
                      {" "}
                      <FaCheck /> Reporting as per NABL ISO guidelines{" "}
                    </li>
                  </ul>
                </div>
                <div className="Package__cardPrice">
                  <span
                    className={card.is_premium ? "text_Color" : "card__Mrp"}
                  >
                    {" "}
                    MRP : &#8377; {card.packPrice}
                  </span>
                  <span
                    className={
                      card.is_premium
                        ? " card__offerPrice  "
                        : "   card__offerPrice textGrey"
                    }
                  >
                    {" "}
                    Offer Price : &#8377; {card.offer_price}
                  </span>
                </div>

                <Link
                  className="Package__BookButton"
                  to={`/${card.slug}-${citySelected.citySelect
                    .toLowerCase()
                    .replace(" ", "-")}`}
                >
                  <span>Book Now</span>
                </Link>
              </div>
            </div>
          ))}
        </div>
      </div> */}

      <div className="covid19">
        <div className="parentDiv  ">
          <div className="childDiv container">
            <div className="HeaderDiv">
              <div className="divHeading">
                <h2>Our Comprehensive Covid Care Packages</h2>
                <p> </p>
              </div>
            </div>
            <Carousel
              swipeable={true}
              draggable={false}
              showDots={false}
              responsive={responsive}
              ssr={true} // means to render carousel on server-side.
              infinite={true}
              autoPlay={false}
              autoPlaySpeed={2500}
              transitionDuration={200}
              deviceType={"tablet"}
            >
              {props?.covidPack?.map((card,index) => {
                if(index < 3)
                {
                return(
                <div
                  className={
                    card.is_premium
                      ? "Package__card bgPremium "
                      : "Package__card bgOrdinary "
                  }
                  key={card.id}
                >
                  <div className="packageTop">
                    <span className={card.is_premium ? "bgGreen" : "bgOrange"}>
                      {card.is_premium ? "Most Popular Plan" : "Heath Check-up"}
                    </span>{" "}
                  </div>

                  <div className="packageBottom">
                    <div className="Package__cardTitle">
                      <span
                        className={card.is_premium ? "textWhite" : "textBlue "}
                      >
                        <Link
                          className={
                            card.is_premium ? "textWhite" : "textBlue "
                          }
                          to={`/${card.slug}${citySelected.citySelect != '' ? `-${citySelected.citySelect
                          .toLowerCase()
                          .replace(" ", "-")}` : ''}`}
                        >
                          {card.name}
                        </Link>
                      </span>
                    </div>
                    <div className="Package__cardList">
                      <ul>
                        <li>
                          {" "}
                          <FaCheck /> Total no.of Tests - {card.parameter}
                        </li>
                        <li>
                          {" "}
                          <FaCheck /> Quick Turn Around Time{" "}
                        </li>
                        <li>
                          {" "}
                          <FaCheck /> Reporting as per NABL ISO guidelines{" "}
                        </li>
                      </ul>
                    </div>
                    <div className="Package__cardPrice">
                      <span
                        className={card.is_premium ? "text_Color" : "card__Mrp"}
                      >
                        {" "}
                        MRP : &#8377; {card?.package_city_prices?.package_price ? card?.package_city_prices?.package_price : card?.package_price}
                      </span>
                      <span
                        className={
                          card.is_premium
                            ? " card__offerPrice  "
                            : "   card__offerPrice textGrey"
                        }
                      >
                        {" "}
                        Offer Price : &#8377; {card?.package_city_prices?.offer_price ? card?.package_city_prices?.offer_price : card?.offer_price}
                      </span>
                    </div>

                    <Link
                      className="Package__BookButton"
                      to={`/${card.slug}${citySelected.citySelect != '' ? `-${citySelected.citySelect
                          .toLowerCase()
                          .replace(" ", "-")}` : ''}`}
                    >
                      <span>Book Now</span>
                    </Link>
                  </div>
                </div>
                )}
              })}
            </Carousel>
          </div>
        </div>
      </div>

      <div className="healthCenter">
        <div className="covidMainContent">
          <h2 className="textPink">Covid 19 Test Centre In Delhi, Noida</h2>
          <p>
            CO-VI-D pieces in three, CO-Corona, VI - Virus and D - Disease and
            was globally introduced as the '2019 novel coronavirus' or
            '2019-nCoV.'
          </p>
          <p>
            It hails from SARS (Severe Acute Respiratory Syndrome) and certain
            common flu virus groups. The SARS-CoV-2 (Severe acute respiratory
            syndrome coronavirus 2), another identity of notorious covid-19, was
            identified as a new strain of Coronavirus by the WHO (World Health
            Organization ) that affected mammals and birds. But now its
            potentials to breach the human immune system causing acute
            respiratory tract infection by oozing fatal viruses into the
            bloodstream resulting in illness and exhibiting symptoms like common
            cold to lethal diseases.
          </p>
          <p>
            Before WHO’s identity allotment, Covid-19 was known as the Wuhan
            Virus. It was identified during the respiratory outbreak in Wuhan
            city, China. The earlier strains of coronavirus are rhinoviruses,
            SARS, MERS (Middle East Respiratory Syndrome), and the recent is the
            COVID-19 is the recent strain.
          </p>
          <p>
            In March 2020 Covid-19 was declared as a global pandemic by the WHO
            owing to its high-velocity transmission rate that spread quickly
            from person to person via coughing, sneezes, or in contact with
            saliva droplets of the infected person. This explains the importance
            of masking, following hygiene norms and maintaining social
            distancing.
          </p>
          <p>
            Fortunately, we now have a standard lab for the Covid test in Delhi
            and across the nation too. There are some reputed centres for Covid
            test in Delhi performing rtpcr-test in Delhi and are available at an
            affordable price range. Covid-19 Vaccination is also available now
            that is clinically tested for effectiveness.
          </p>
        </div>
      </div>

      <div className="covidVaccine  ">
        <h2 className="textPink">COVID-19 Vaccine</h2>
        <p className="normalText">
          COVID-19 vaccines are now available at centres for the Covid test in
          Delhi. There are various government and private authorized COVID
          centres in Delhi and Pan-India.
        </p>
        <p className="normalText">
          The third wave is expected to be more fatal compared to the first and
          the second wave and is about to knock soon. Hence, it is important for
          people aged above 18 years to get vaccinated by visiting the nearest
          covid19 test labs in Delhi. The Delhi Government facilitates
          sufficient Corona-Testing Labs in Delhi. The convenience of Covid
          Testing at home in Delhi is also available providing DIY for adults.
          It is to be noted that registration is a must for the 18-44 year age
          group.
        </p>
      </div>

      <div className="documents">
        <div className="covidMainContent">
          <h2 className="textPink"> Documents required for COVID-19 Vaccine</h2>
          <p>One needs to produce any of the following ID with photo:</p>
          <ul>
            <li>PAN Card </li>
            <li>Aadhar Card </li>
            <li>Driving License</li>
            <li> Passport </li>
            <li>Pension Document</li>
            <li>Voter ID</li>
            <li> MGNREGA Job Card</li>
          </ul>
        </div>
      </div>
      <div className="documents delhi">
        <div className="covidMainContent">
          <h2 className="textPink"> COVID Test in Delhi</h2>

          <ul>
            <li> Covid-19 RTPCR</li>
            <li> Covid- 19 total Antibodies </li>
            <li> Covid-19 Antigen Test </li>
            <li> Covid 19 IgG Antibodies </li>
          </ul>
        </div>
      </div>
      <div className="documents">
        <div className="covidMainContent">
          <h2 className="textPink"> Symptoms</h2>

          <ul>
            <li> Breathlessness</li>
            <li> Cough </li>
            <li> Fever </li>
            <li> Chest Pain </li>
            <li> Phlegm </li>
            <li> Pneumonia</li>
          </ul>
        </div>
      </div>
      <FAQforhomepage />
      <ScrolltoTop />
      <Footer />
      <SubFooter />
    </React.Fragment>
  );
}

const mapStateToProps = (state) => ({
  covidPack: state.NewCovidReducer.CovidPackage,
  SelCity: state?.cityOnTopNav?.citySelect,
})

const mapDispatchToProps = (dispatch) => {
  return {
    getCovidpackage: (search,city) => {
      dispatch(Actions.getCovidpackage(search,city));
    },

  }
}
export default {
  component: connect(mapStateToProps, mapDispatchToProps)(React.memo(Newcovid)),
};
